import React,{ useState,useEffect } from "react"
import Slider from "react-slick"

import "../../../node_modules/slick-carousel/slick/slick.css"
import "../../../node_modules/slick-carousel/slick/slick-theme.css"


const slickSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  centerMode: false,
  variableWidth: false,
  arrows: true,
  responsive: [
     {
     breakpoint: 980,
     settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
     }
     }
  ],
}

  function FeefoReviews({ FeefoReviewsTitle }){
    const [apiContent, setApiContent] = useState([])
    const [apiMetaContent, setApiMetaContent] = useState([])
    const customerContent=[]
    const reviewContent=[]
    const metaContent=[]


    // Example POST method implementation:

    useEffect(() => {

    var request = new Request('https://api.feefo.com/api/10/reviews/service?merchant_identifier=hampshire-trust-bank&fields=reviews.service.rating.rating,reviews.service.review,reviews.service.title,reviews.last_updated_date,reviews.customer.display_name&rating=4,5&tags=[campaign:Savings%20Retail]&page_size=10', {
	     headers: new Headers({
		       'Content-Type': 'text/plain'
    	    })
    });

    var dataRequest = new Request('https://api.feefo.com/api/10/reviews/summary/all?merchant_identifier=hampshire-trust-bank', {
	     headers: new Headers({
		       'Content-Type': 'text/plain',
    	    })
    });


fetch(dataRequest).then(function(response) {
	// Convert to JSON
	return response.json();
}).then(function(p) {
	// Yay, `j` is a JavaScript object
  metaContent.push({
    count: p.meta.count,
    rating: p.rating.rating
  })
  setApiMetaContent(metaContent)
});

fetch(request).then(function(response) {
	// Convert to JSON
	return response.json();
}).then(function(j) {
	// Yay, `j` is a JavaScript object
  //console.log(j);
  j.reviews.forEach(function(content) {
     //console.log(content);
     var now = new Date();
     var datefromAPITimeStamp = (new Date(content.last_updated_date)).getTime();
     var nowTimeStamp = now.getTime();
     var microSecondsDiff = Math.abs(datefromAPITimeStamp - nowTimeStamp );
     var daysDiff = Math.floor(microSecondsDiff/(1000 * 60 * 60  * 24))+" days ago";

     if(content.customer){
       customerContent.push({
         name: content.customer.display_name,
         lastUpdated: content.last_updated_date,
         rating: content.service.rating.rating,
         review: content.service.review,
         title: content.service.title
       })
     }
     else{
       reviewContent.push({
         lastUpdated: daysDiff,
         rating: content.service.rating.rating,
         review: content.service.review,
         title: content.service.title
       })
     }

  });
  //console.log(reviewContent)
  setApiContent(reviewContent)

});


    }, []);

  return (
    <>
    <section id="feefo" className="content pale-grey-background">

<div className="content-block">


  <div className="eighty-spacer"></div>

    <h3 className="savings-title"><a href="https://www.feefo.com/en-GB/reviews/hampshire-trust-bank"><span>
    <img src="/htbcontent/themes/htb-personal/assets/img/feefo-logo.png" alt="Feefo Logo" /></span></a>  Latest Ratings & Reviews</h3>
   <div className="centered-content-container">
      <div className="centered-intro-text-holder no-bottom-pad">
         Don't just take our word for it.
      </div>
   </div>



  <div className="eighty-spacer"></div>
  {apiContent ?
    <Slider className="review-slider" {...slickSettings}>
    {apiContent.length
      ? apiContent.map((apiItem,index) => (
        <span key={index}>
        <div className="reviews">
        <div className="review-block">
        <img src={`/htbcontent/themes/htb-personal/assets/img/${apiItem.rating}.0.png`} alt="Feefo Rating"/>
        <div className="review-title">{apiItem.title}</div>
        <div className="review-paragraph">{apiItem.review}</div>
        <div className="review-name">{apiItem.lastUpdated}</div>
        <div className="eighty-spacer"></div></div></div>
        </span>
      ))
    : null}
    </Slider>
    : null}
<div className="center-block">
  <div className="read-external-reviews">
      {apiMetaContent[0] ?
        <>
        <span> {apiMetaContent[0].count} / 5</span> rating. Based on <span>{apiMetaContent[0].rating}</span> service ratings over the past year <a target="_blank" href="https://www.feefo.com/en-GB/reviews/hampshire-trust-bank" rel="noopener noreferrer">Read all our reviews at Feefo</a>
        </>
        :null}
  </div>

  <a href="/personal-savings/personal-savings-reviews/">
    <div className="read-reviews">
      Read More Reviews
    </div>
  </a>
</div>

</div>

</section>
</>
  )
  }


export default FeefoReviews
